<template>
  <div class="main-background">
    <img class="background-image" :src="$assets.image.background['events_background.jpeg']" alt="" />

    <EventBanner v-if="bannerEvent" :evEvent="bannerEvent" />

    <div class="types" v-if="evEvents.length > 0">
      <div v-for="type in types" :key="type.code" class="type">
        <div class="type-header">
          <p>
            {{ type.text }} |
            <router-link class="view-more" :to="{ name: 'typeEvents', params: { typecode: type.code.toLowerCase() } }">
              View More >>
            </router-link>
          </p>
          <div class="line" />
        </div>

        <CardsRow :evEvents="evEvents.filter((ev) => ev.type_code === type.code)" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';

import $assets from '@/assets';
import CardsRow from '@/components/event/CardsRow.vue';
import EventBanner from '@/components/event/EventBanner.vue';
import EventService from '@/services/event';
import MetaService from '@/services/meta';
import $conversion from '@/utils/conversion';
import Logger from '@/utils/logger';

const types = ref([]);
const evEvents = ref([]);
const bannerEvent = ref(null);

onBeforeMount(async () => {
  const eventTypeResults = await MetaService.getMetasByType('event_type');
  types.value = eventTypeResults.records
    .filter((t) => t.meta_code !== 'HUB-TRAINING')
    .map((t) => ({ code: t.meta_code, text: t.meta_value }));

  const eventResults = await EventService.getEvents();
  evEvents.value = eventResults.records.map((evEvent) => {
    // Make all fields work with ui logic
    const eventUIData = $conversion.eventToUI(evEvent);

    Logger.debug(evEvent);

    // Banner event
    if (eventUIData.is_banner) {
      bannerEvent.value = eventUIData;
    }

    return eventUIData;
  });
});
</script>

<style scoped>
.main-background {
  position: relative;
  min-height: calc(100% - 169px);
  padding-bottom: 169px;

  background: linear-gradient(180deg, #002936 0%, #1f184b 100%);
}

@media (min-width: 1440px) {
  .main-background {
    font-size: 18px;
  }
}

.background-image {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;

  opacity: 0.15;
}

.types {
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.type {
  width: 100%;
  max-width: 1666px;

  color: white;
}

.type-header {
  width: 85%;
  margin: 0 auto;
}

.view-more {
  color: inherit;
  text-decoration: none;
}

.line {
  width: 100%;
  height: 1px;
  margin-bottom: 15px;

  border-top: 1px solid currentColor;
}
</style>
